<template>
    <section id="contact-section">
        <div class="contact-container">
            <div class="contact-form">
                <form name="contactForm">
                    <md-input-container v-for="(field, index) in contactFormSchema" :key="index">
                        <md-input required :id="field.attribute" :label="field.name" :type="field.type"
                            v-model="modelValue[field.attribute]" />
                        <label :for="field.attribute">{{ field.name }} </label>
                    </md-input-container>
                </form>
                
                <p v-if="notValid" class="contact-error">Please provide your name and email so we can reach out to you.
                </p>
                <md-button type="submit" form="contactForm" @click="onSubmit">Contact me</md-button>
            </div>
        </div>
    </section>
</template>

<script lang="ts">;
export default {
    name: 'ContactSection',
    data() {
        return {
            contactFormSchema: [
                {
                    attribute: 'contactName',
                    name: 'Your name',
                    type: 'text'
                },
                {
                    attribute: 'contactEmail',
                    name: 'Your email',
                    type: 'email'
                }
            ],
            modelValue: {
                contactName: '',
                contactEmail: ''
            },
            notValid: false
        };
    },
    methods: {
        onSubmit() {
            if (this.modelValue.contactName && this.modelValue.contactEmail) {
                this.notValid = false;
                this.openZendesk();
            } else {
                this.notValid = true;
            }
        },
        openZendesk() {
            const zE = (window as any).zE;
            zE.identify({
                name: this.modelValue.contactName,
                email: this.modelValue.contactEmail
            });

            zE('webWidget', 'updateSettings', {
                webWidget: {
                    helpCenter: {
                        suppress: true,
                    },
                    contactForm: {
                        fields: [
                            { id: 'name', prefill: { '*': this.modelValue.contactName } },
                            { id: 'email', prefill: { '*': this.modelValue.contactEmail } }
                        ]
                    }
                }
            });
            zE('webWidget', 'open');
            zE('webWidget:on', 'close', () => {
                zE('webWidget', 'updateSettings', {
                    webWidget: {
                        helpCenter: {
                            suppress: false,
                        },
                    }
                });
            })
            zE('webWidget', 'reset');
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../sass/vars.scss";

#contact-section {
    .contact-container {

        .contact-form {
            display: flex;
            flex-direction: column;
            align-items: flex-end;

            form {
                width: 100%;
            }
            .md-input-container {
                margin-bottom: 8px;
                min-height: 56px;
                padding: 0px 19px 0px 16px;
                border-radius: 4px;
                background: #FFF;

                label {
                    left: 16px;
                    top: 18px;
                    color: $text-contrast-54;
                    font-size: 14px;
                    line-height: 20px;

                    &:after {
                        display: none;
                    }
                }

                &.md-has-value {
                    label {
                        top: 0;
                        font-size: 12px;
                    }
                }

                .md-input {
                    padding-top: 20px;
                    height: 50px;
                    border: none;
                    margin: 0;
                    height: auto;
                    box-shadow: none;
                }
            }

            .md-button {
                border-radius: 4px;
                background: #354860;
                height: 40px;
                font-size: 14px;
                font-weight: 600;
                line-height: 20px;
                color: #FFF;
                padding: 10px 16px;
                margin-bottom: 20px;
                float: right;
                margin-right: 0 !important;
            }

            p {
                color: $text-contrast-87;
                font-size: 12px;
                line-height: 14px;

                a {
                    color: $text-contrast-87;
                    text-decoration: underline;
                }
            }

            .contact-error {
                color: #FF0000;
                margin-top: 8px;
                margin-bottom: 0;
            }
        }
    }
}
</style>